import {html} from '@isceco/widget-library2/external/lit'
import {unsafeHTML} from '@isceco/widget-library2/external/lit/directives/unsafe-html.js'
import '@isceco/widget-library2/basic-elements/List/StaticList'
import {sanitizeRichTextHtml} from './utils.js'

export function renderMindestloehneContent(ctx, helpers) {
  const {renderHintAccordions, salaryListColumns} = helpers
  const row = ctx.getMatchingDetailRow()
  let salaryTable
  if (!ctx.isSalaryTableReady()) {
    salaryTable = html`<p class="salary-table-placeholder">${ctx.i18n.translate('mindestlohnrechner.details.salary.waitForSelection')}</p>`
  } else if (hasNoBasicSalary(row)) {
    salaryTable = renderNoBasicSalaryMessage(ctx)
  } else {
    salaryTable = renderSalaryTable(ctx, row, salaryListColumns)
  }
  const visibleFields = ctx.getVisibleEmployeeFields()

  return html`
    <div class="detail-content-section">
      <isceco-card>
        <div class="mindestloehne-card-content">
          <div class="employee-data-header">
            <h3>${ctx.i18n.translate('mindestlohnrechner.details.employeeDataTitle')}</h3>
            <span class="employee-data-loading" ?hidden="${!(ctx.isLoadingCriteria || ctx.isLoadingResult)}">
              ${ctx.i18n.translate('mindestlohnrechner.details.loading')}
            </span>
          </div>
          <div class="employee-fields-grid">
            ${visibleFields.map(field => html`
              <div class="employee-field-item">
                <label>${field.label}</label>
                <isceco-dropdown
                  .items="${[
                    { value: '', name: ctx.i18n.translate('mindestlohnrechner.details.selectPlaceholder') },
                    ...((field.options || []).map(option => ({ value: option.value, name: option.label })))
                  ]}"
                  .value="${ctx.currentSelections[String(field.criteriaStructureId)] || ''}"
                  ?disabled="${!ctx.isEmployeeFieldEnabled(field.criteriaStructureId)}"
                  @change="${event => ctx.updateEmployeeSelection(field.criteriaStructureId, event.target.value)}"
                ></isceco-dropdown>
              </div>
            `)}
          </div>
          ${!(ctx.isLoadingCriteria || ctx.isLoadingResult) && visibleFields.length === 0
            ? html`<p>${ctx.i18n.translate('mindestlohnrechner.details.noEmployeeFields')}</p>`
            : ''}
          ${salaryTable}
        </div>
      </isceco-card>

      ${renderHintAccordions(ctx)}
    </div>
  `
}

function hasNoBasicSalary(row) {
  return Boolean(row) && Number(row.basicSalary) === 0
}

function renderNoBasicSalaryMessage(ctx) {
  const message = sanitizeRichTextHtml(ctx.i18n.translate('mindestlohnrechner.details.salary.noBasicSalary'))
  return html`
    <div class="salary-table">
      <p class="salary-no-basic" @click="${event => ctx.handleHintContentClick(event)}">${unsafeHTML(message)}</p>
    </div>
  `
}

function renderSalaryTable(ctx, row, salaryListColumns) {
  if (!row) {
    return ''
  }
  const salaryRows = [
    { label: ctx.i18n.translate('mindestlohnrechner.details.salary.basic'), value: ctx.formatCurrency(row.basicSalary) },
    { label: ctx.i18n.translate('mindestlohnrechner.details.salary.vacationDays'), value: row.vacationDays ?? '-' },
    { label: ctx.i18n.translate('mindestlohnrechner.details.salary.vacationCompensation'), value: ctx.formatCurrency(row.vacationCompensation) },
    { label: ctx.i18n.translate('mindestlohnrechner.details.salary.publicHolidays'), value: row.publicHolidays ?? '-' },
    { label: ctx.i18n.translate('mindestlohnrechner.details.salary.publicHolidaysCompensation'), value: ctx.formatCurrency(row.publicHolidaysCompensation) },
    {
      label: ctx.i18n.translate('mindestlohnrechner.details.salary.has13th'),
      value: row.has13thMonthSalary
        ? ctx.i18n.translate('mindestlohnrechner.common.yes')
        : ctx.i18n.translate('mindestlohnrechner.common.no')
    },
    { label: ctx.i18n.translate('mindestlohnrechner.details.salary.compensation13th'), value: ctx.formatCurrency(row.compensation13thSalary) }
  ]
  const staticListData = salaryRows.map(entry => ({ dto: entry }))
  return html`
    <div class="salary-table">
      <p class="salary-table-title">${ctx.i18n.translate('mindestlohnrechner.details.salary.title')}</p>
      <isceco-static-list
        class="salary-static-list"
        .i18n="${ctx.i18n}"
        .columns="${salaryListColumns}"
        .data="${staticListData}"
      ></isceco-static-list>
    </div>
  `
}
